<script>
import {mapState} from "vuex";
import planCommon from './mixin';
import {filter, get, orderBy} from "lodash";
import {planTypes} from "@/common/constants";
import base from '@/views/config/addon-cards/templates/base.vue';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';
import { planTypesForMeeting } from '@/views/config/addon-cards/index.vue';
import { isSimilarProPlusBundle } from '@/views/config/soft-bundle/helper';
import addonCustomSelect from '@/plans/mx/addonCustomSelect';

export default {
  name: 'LargeMeetingAddon',
  mixins: [base, planCommon, addonCustomSelect],
  for: ()=> {
      const shouldHide = isZoomMeetingAsAddonCard();
      if(shouldHide) return [];
      return planTypesForMeeting();
  },
  data() {
    return {
      promo: isSimilarProPlusBundle() ? "" : this.$t('billing.common.popular'),
    }
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    currentProductPlans() {
      return orderBy(filter(this.planMapFlat, (p) => p.type === planTypes.LARGE_MEETING && !p.isOneMonth), ['participants', 'amount'], 'asc');
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
  }
};
</script>
